<template>
  <success title="已提交" @close="handlerClose" ref="suc">
    <p class="result-info"  v-if="reviewers">请等候{{reviewers}}的审核</p>
  </success>
</template>
<script>
import cache from '../../common/cache'
import Success from '../components/Success'
export default {
  components: {
    Success
  },
  data() {
    return {
      sessionKey: '',
      reviewerList: []
    }
  },
  computed: {
    reviewers() {
      let reviewerList = this.reviewerList || []
      let reviewers = []
      reviewerList.forEach((val) => {
        reviewers.push(val.employee_name)
      })
      return reviewers.join(',')
    },
    isDOS() {
      return this.$store.state.isDOS
    }
  },
  created() {
    this.sessionKey = this.$route.params.sessionKey
    this.reviewerList = cache.getSessionData(this.sessionKey)
  },
  beforeRouteLeave(to, from, next) {
    this.$refs.suc.close()
  },
  methods: {
    handlerClose() {
      cache.clearSessionData(this.sessionKey)
    }
  }
}

</script>
